/* ============================================================
   Centric variant tools
   Replaces: "Color Swatch Pug" (color swatches) and
             "Variant Image Penguin" (gallery image filtering + main image swap)
   Theme: Narrative (uses select.single-option-selector[data-option-input])

   HOW IMAGE FILTERING WORKS
   Tag gallery images via their alt text in Shopify admin:
     "Strap close-up #brown-classic"          -> shows only when the selected
                                                 variant matches brown-classic
     "Lifestyle shot #tan-classic,tan-modern" -> shows for either
     "Watch face detail"                      -> no tag: always visible
   A tag matches when it appears inside the slugified selected variant
   title (e.g. "Brown Classic Leather Strap" -> brown-classic-leather-strap,
   so #brown-classic matches).
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Config ------------------------------------------------ */

  // Option names that get swatches (case-insensitive substring match)
  var SWATCH_OPTION_PATTERN = /colou?r|strap|hardware/i;

  // Custom color overrides — add your own here. Keys are lowercase.
  var CUSTOM_COLORS = {
    'tan': '#c8a165',
    'gilt': '#c9a84c',
    'gunmetal': '#4a4d50',
    'ivory': '#f4f1e8',
    'brushed stainless steel': '#c8ccd0',
    'stainless steel': '#c8ccd0',
    'pvd': '#3a3d40'
  };

  // Standard CSS color names (subset; extend as needed)
  var CSS_COLORS = ['black', 'white', 'red', 'blue', 'green', 'yellow',
    'orange', 'purple', 'pink', 'brown', 'gray', 'grey', 'navy', 'teal',
    'olive', 'maroon', 'silver', 'gold', 'beige', 'coral', 'crimson',
    'cyan', 'darkblue', 'darkgreen', 'darkred', 'indigo', 'ivory',
    'khaki', 'lavender', 'lime', 'magenta', 'mint', 'salmon', 'sienna',
    'tan', 'turquoise', 'violet', 'wheat', 'charcoal', 'burgundy'];

  var NON_STANDARD = {
    'mint': '#98e2c6', 'charcoal': '#36454f', 'burgundy': '#800020'
  };

  /* ---------- Helpers ------------------------------------------------ */

  function slugify(str) {
    return String(str).toLowerCase().trim()
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function colorFor(value) {
    var lower = value.toLowerCase();

    if (CUSTOM_COLORS[lower]) return CUSTOM_COLORS[lower];
    var keys = Object.keys(CUSTOM_COLORS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      if (lower.indexOf(keys[i]) !== -1) return CUSTOM_COLORS[keys[i]];
    }

    var words = lower.replace(/[^a-z ]/g, '').split(/\s+/);
    for (var j = 0; j < words.length - 1; j++) {
      var joined = words[j] + words[j + 1];
      if (CSS_COLORS.indexOf(joined) !== -1) return NON_STANDARD[joined] || joined;
    }
    for (var k = 0; k < words.length; k++) {
      if (CSS_COLORS.indexOf(words[k]) !== -1) return NON_STANDARD[words[k]] || words[k];
    }
    return null;
  }

  /* ---------- Swatches ---------------------------------------------- */

  function buildSwatches(formItem, select) {
    var wrapper = document.createElement('div');
    wrapper.className = 'cs-swatch-wrapper';
    wrapper.setAttribute('role', 'group');

    Array.prototype.forEach.call(select.options, function (opt) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cs-swatch';
      btn.dataset.value = opt.value;
      btn.title = opt.value;
      btn.setAttribute('aria-label', opt.value);
      btn.setAttribute('aria-pressed', opt.selected ? 'true' : 'false');

      var color = colorFor(opt.value);
      if (color) {
        btn.style.backgroundColor = color;
      } else {
        btn.classList.add('cs-swatch--text');
        btn.textContent = opt.value;
      }

      btn.addEventListener('click', function () {
        if (select.value === opt.value) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });

      wrapper.appendChild(btn);
    });

    select.insertAdjacentElement('afterend', wrapper);
    formItem.classList.add('cs-swatches-active');

    var label = formItem.querySelector('label');
    var selLabel = document.createElement('span');
    selLabel.className = 'cs-swatch-selected-label';
    if (label) label.insertAdjacentElement('afterend', selLabel);

    return function refresh() {
      Array.prototype.forEach.call(wrapper.children, function (btn) {
        btn.setAttribute('aria-pressed',
          btn.dataset.value === select.value ? 'true' : 'false');
      });
      selLabel.textContent = select.value;
    };
  }

  /* ---------- Main image swap (replaces Penguin's variant-image toggle) */

  function findVariant(productData, selects) {
    if (!productData || !productData.variants) return null;
    var values = Array.prototype.map.call(selects, function (s) { return s.value; });
    return productData.variants.filter(function (v) {
      return values.every(function (val, i) { return v['option' + (i + 1)] === val; });
    })[0] || null;
  }

  function updateMainImage(sectionEl, productData, selects) {
    var variant = findVariant(productData, selects);
    if (!variant || !variant.featured_image) return;
    var imgId = String(variant.featured_image.id);
    var containers = sectionEl.querySelectorAll('.product__image-container');
    Array.prototype.forEach.call(containers, function (c) {
      var show = String(c.getAttribute('data-id')) === imgId;
      c.classList.toggle('hide', !show);
      if (show) {
        // Lazy-loaded images that were hidden may have no src yet
        var img = c.querySelector('img');
        if (img && !img.getAttribute('src') && img.getAttribute('data-src')) {
          img.setAttribute('src', img.getAttribute('data-src').replace('{width}', '900'));
        }
      }
    });
  }

  /* ---------- Gallery filtering (Variant Image Penguin clone) -------- */

  function parseTags(alt) {
    var tags = [];
    var re = /#([a-z0-9_,-]+)/gi;
    var m;
    while ((m = re.exec(alt)) !== null) {
      m[1].split(',').forEach(function (t) {
        t = t.trim().toLowerCase();
        if (t) tags.push(t);
      });
    }
    return tags;
  }

  function filterGallery(sectionEl, selects) {
    var selectedSlug = slugify(
      Array.prototype.map.call(selects, function (s) { return s.value; }).join(' ')
    );

    var items = sectionEl.querySelectorAll('.product__subimage-list-item');
    var visible = 0;

    Array.prototype.forEach.call(items, function (item) {
      var img = item.querySelector('img');
      var alt = img ? (img.getAttribute('alt') || '') : '';
      var tags = parseTags(alt);

      var show = tags.length === 0 || tags.some(function (tag) {
        return selectedSlug.indexOf(tag) !== -1;
      });

      item.classList.toggle('cs-hidden', !show);
      if (show) visible++;
    });

    var list = sectionEl.querySelector('.product__subimage-list');
    if (list && visible > 0) {
      list.className = list.className.replace(/product__subimage-list--r\d/,
        'product__subimage-list--r' + (visible % 3));
    }
  }

  /* ---------- Init --------------------------------------------------- */

  function initSection(sectionEl) {
    var selects = sectionEl.querySelectorAll('select.single-option-selector[data-option-input]');
    if (!selects.length) return;

    // Clean up any previous init (the theme editor re-renders sections)
    Array.prototype.forEach.call(
      sectionEl.querySelectorAll('.cs-swatch-wrapper, .cs-swatch-selected-label'),
      function (el) { el.parentNode.removeChild(el); }
    );

    var productData = null;
    var jsonEl = sectionEl.querySelector('[data-product-json]');
    if (jsonEl) {
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { /* noop */ }
    }

    var refreshers = [];

    Array.prototype.forEach.call(selects, function (select) {
      var formItem = select.closest('.product-form__item');
      var optionName = select.id || '';
      if (formItem && SWATCH_OPTION_PATTERN.test(optionName)) {
        refreshers.push(buildSwatches(formItem, select));
      }

      select.addEventListener('change', function () {
        refreshers.forEach(function (fn) { fn(); });
        filterGallery(sectionEl, selects);
        updateMainImage(sectionEl, productData, selects);
      });
    });

    refreshers.forEach(function (fn) { fn(); });
    filterGallery(sectionEl, selects);
    updateMainImage(sectionEl, productData, selects);
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-section-type="product-template"]'),
      initSection
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-section-type="product-template"]');
    if (el) initSection(el);
  });
})();
